export default "/_next/static/images/solutions--engagement-bc48a36991ab0b915c148bd61c6c1d06.svg";